/* eslint-disable new-cap */
//

import { normalize } from 'normalizr';
import immutable from 'immutable';

import { simplApi } from '../../api/simplApi';
import { task } from './schemas';
import { fetchTotalData } from './totaldata';
import handleApiError from '../../helpers/handleApiError';
import { addFeedback } from './feedback';
import { receiveFile } from './file';

const _ = require('lodash');

// ------------------------------------
// Constants
// ------------------------------------
export const REQUEST_TASK = 'REQUEST_TASK';
export const SET_TASK = 'SET_TASK';
export const REMOVE_TASK = 'REMOVE_TASK';
export const RECEIVE_TASK = 'RECEIVE_TASK';
export const TOGGLE_TASKBAR = 'TOGGLE_TASKBAR';
export const COMMENT_TASK = 'COMMENT_TASK';

// ------------------------------------
// Actions
// ------------------------------------

export function requestTask() {
  return {
    type: REQUEST_TASK,
  };
}

export function setTask(taskId) {
  return {
    type: SET_TASK,
    payload: taskId,
  };
}

export function toggleTaskBar() {
  // console.log('toggling taskbar');
  return {
    type: TOGGLE_TASKBAR,
  };
}

export function receiveTask(tasks) {
  return {
    type: RECEIVE_TASK,
    payload: {
      tasks,
    },
  };
}

export function removeTask(taskId) {
  return {
    type: REMOVE_TASK,
    payload: taskId,
  };
}

export const deleteTask = taskId => dispatch => {
  const url = `task/${taskId}`;
  const options = { method: 'delete' };

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        dispatch(removeTask(taskId));
        dispatch(addFeedback('warning', 'Aufgabe gelöscht'));
      }
    });
};

export const fetchTask = taskId => dispatch => {
  dispatch(requestTask());

  const url =
    typeof taskId !== 'undefined' && taskId !== null
      ? `task/${taskId}`
      : 'task';

  simplApi(url)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        let preparedTasks;

        if (typeof json.id === 'undefined') {
          preparedTasks = normalize(json, [task]);
        } else {
          preparedTasks = normalize(json, task);
        }

        dispatch(receiveTask(preparedTasks.entities.tasks));
      }
    });
};

export const saveTask = newTask => dispatch => {
  dispatch(requestTask());

  // // console.log('saving Task', newTask);

  let url = 'task/';
  const options = { method: 'post', body: newTask };
  if (typeof newTask.id !== 'undefined' && newTask.id !== null) {
    // // console.log('updating');
    url = `${url}${newTask.id}`;
    options.method = 'put';
  }

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        const preparedTasks = normalize(json, task);

        dispatch(addFeedback('success', 'Aufgabe gespeichert'));
        dispatch(receiveTask(preparedTasks.entities.tasks));
        dispatch(receiveFile(preparedTasks.entities.files));
        dispatch(fetchTotalData());
      }
    });
};

export const commentTask = (taskId, comment) => dispatch => {
  dispatch(requestTask());

  const url = `task/${taskId}/comment`;
  const options = { method: 'post', body: comment };

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        const preparedTasks = normalize(json, task);

        dispatch(receiveTask(preparedTasks.entities.tasks));
      }
    });
};

export const actions = {
  requestTask,
  setTask,
  receiveTask,
  toggleTaskBar,
  fetchTask,
  saveTask,
  commentTask,
  removeTask,
  deleteTask,
};

const TASK_ACTION_HANDLERS = {
  [REQUEST_TASK]: state => ({
    ...state,
    fetching: true,
  }),
  [SET_TASK]: (state, action) => ({ ...state, current: action.payload }),
  [TOGGLE_TASKBAR]: state => ({
    ...state,
    open: !state.open,
  }),
  [REMOVE_TASK]: (state, action) => ({
    ...state,
    tasks: _.omit(state.tasks, action.payload),
  }),
  [RECEIVE_TASK]: (state, action) => {
    const stateTasks = immutable.Map(state.tasks);

    _.forOwn(action.payload.tasks, (_task, id) => {
      const newTask = Object.assign({}, _task);

      if (typeof stateTasks[id] === 'object') {
        stateTasks[id] = Object.assign({}, stateTasks[id], newTask);
      } else {
        stateTasks[id] = newTask;
      }
    });

    return {
      ...state,
      tasks: stateTasks,
      fetching: false,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------

export const initialState = {
  fetching: false,
  current: null,
  formOpen: false,
  formTarget: null,
  open: false,
  tasks: {},
};
export default function taskReducer(state = initialState, action) {
  const handler = TASK_ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/task.js